import {useSelector} from 'react-redux';
import type {RootState} from '@local/redux/store';
import type {UserState} from '@local/redux/state/user';

export const useUser = () => {
  return useSelector<RootState, UserState>(({user}) => user);
};
